module.exports = __webpack_public_path__ + "choose-image.db1937ca7f18c18df016811ab88e75cd.hashedasset.svg";